import { renderDate } from '@intrasync/utils';
import { renderTime } from '@intrasync/utils';
import ResetIcon from '@mui/icons-material/RestartAlt';

import React from 'react';

import Button from '../../Button/Button';
import DatePicker from '../../DatePicker/DatePicker';
import FlexRow from '../../Flex/FlexRow';
import Input from '../../Input/Input';
import Select from '../../Select/Select';
import SelectItem from '../../Select/SelectItem';
import TimePicker from '../../TimePicker/TimePicker';
import injectStores from '../../RootStore/injectStores';
import { DataGridStore } from 'stores/index';
import { DataGridColumnHeader } from 'types/DataGridTypes';

interface DataGridBodyFullGridEditCellProps {
  cellDataType: string;
  cellEditValue: string;
  cellHeight: number;
  cellWidth: number;
  cellActualValue: string;
  cellHeader: DataGridColumnHeader;
  cellUniqueKey: string;
  cellEditKey: string;
  dataGridStore?: DataGridStore;
  namespaceId: string;
}

class DataGridBodyFullGridEditCell extends React.PureComponent<DataGridBodyFullGridEditCellProps> {
  // Note: Not using makeObservable with computed for getters that read from props
  // as props are not observable in MobX. These are just regular getters.

  get currentStore() {
    const { dataGridStore, namespaceId } = this.props;
    return dataGridStore?.namespaces[namespaceId];
  }

  setEditValue = (value: string) => {
    const { cellUniqueKey, cellEditKey } = this.props;

    if (cellUniqueKey && this.currentStore) {
      this.currentStore.setEditData(cellUniqueKey, {
        [cellEditKey]: value,
      });
    }
  };

  cancelEdit = () => {
    const { cellUniqueKey, cellEditKey } = this.props;
    if (cellUniqueKey && this.currentStore) {
      this.currentStore.removeEditData(cellUniqueKey, cellEditKey);
    }
  };

  get hasBeenEdited() {
    const { cellEditValue } = this.props;
    return !!cellEditValue;
  }

  get renderValue() {
    const { cellEditValue, cellActualValue } = this.props;
    return this.hasBeenEdited ? cellEditValue : cellActualValue;
  }
  get columnChoices() {
    const { cellHeader } = this.props;
    return cellHeader?.choices || [];
  }

  render() {
    const { cellDataType, cellHeight, cellWidth, cellActualValue } = this.props;
    if (this.columnChoices?.length > 0) {
      return (
        <FlexRow
          style={{ height: cellHeight, width: cellWidth, alignItems: 'center' }}
        >
          <Select
            onChange={(value: string) => {
              this.setEditValue(value);
            }}
            value={this.renderValue}
            label={cellActualValue}
          >
            {this.columnChoices.map((choice) => {
              return (
                <SelectItem
                  key={choice}
                  value={choice}
                  style={{ minHeight: 40 }}
                />
              );
            })}
          </Select>
          <Button
            size="small"
            justIcon
            color={this.hasBeenEdited ? 'warning' : 'transparent'}
            onClick={() => this.cancelEdit()}
          >
            <ResetIcon />
          </Button>
        </FlexRow>
      );
    }
    if (cellDataType === 'boolean') {
      return (
        <FlexRow
          style={{
            height: this.hasBeenEdited ? cellHeight - 4 : cellHeight,
            width: this.hasBeenEdited ? cellWidth - 4 : cellWidth,
            alignItems: 'center',
            border: this.hasBeenEdited ? '2px solid orange' : undefined,
          }}
        >
          <Select
            onChange={(value: string) => {
              this.setEditValue(value);
            }}
            value={this.renderValue}
            label={cellActualValue}
          >
            <SelectItem key="True" value="True" />
            <SelectItem key="False" value="False" />
          </Select>
          <Button
            size="small"
            justIcon
            color={this.hasBeenEdited ? 'warning' : 'transparent'}
            onClick={() => this.cancelEdit()}
          >
            <ResetIcon />
          </Button>
        </FlexRow>
      );
    }
    if (cellDataType === 'date') {
      return (
        <FlexRow
          style={{
            height: this.hasBeenEdited ? cellHeight - 4 : cellHeight,
            width: this.hasBeenEdited ? cellWidth - 4 : cellWidth,
            alignItems: 'center',
            border: this.hasBeenEdited ? '2px solid orange' : undefined,
          }}
        >
          <DatePicker
            label={renderDate(cellActualValue)}
            value={this.renderValue}
            showClearButton
            onChange={(value) => this.setEditValue(value)}
          />
          <Button
            size="small"
            justIcon
            color={this.hasBeenEdited ? 'warning' : 'transparent'}
            onClick={() => this.cancelEdit()}
          >
            <ResetIcon />
          </Button>
        </FlexRow>
      );
    }

    if (cellDataType === 'time') {
      return (
        <FlexRow
          style={{
            height: this.hasBeenEdited ? cellHeight - 4 : cellHeight,
            width: this.hasBeenEdited ? cellWidth - 4 : cellWidth,

            alignItems: 'center',
            border: this.hasBeenEdited ? '2px solid orange' : undefined,
          }}
        >
          <TimePicker
            label={renderTime(cellActualValue)}
            value={this.renderValue}
            showClearButton
            onChange={(value) => this.setEditValue(value)}
          />
          <Button
            size="small"
            justIcon
            color={this.hasBeenEdited ? 'warning' : 'transparent'}
            onClick={() => this.cancelEdit()}
          >
            <ResetIcon />
          </Button>
        </FlexRow>
      );
    }

    return (
      <FlexRow
        style={{
          height: this.hasBeenEdited ? cellHeight - 4 : cellHeight,
          width: this.hasBeenEdited ? cellWidth - 4 : cellWidth,
          alignItems: 'center',
          border: this.hasBeenEdited ? '2px solid orange' : undefined,
        }}
      >
        <Input
          labelText={cellActualValue}
          value={this.renderValue}
          onChange={(value) => this.setEditValue(value)}
        />
        <Button
          size="small"
          justIcon
          color={this.hasBeenEdited ? 'warning' : 'transparent'}
          onClick={() => this.cancelEdit()}
        >
          <ResetIcon />
        </Button>
      </FlexRow>
    );
  }
}

export default injectStores(DataGridBodyFullGridEditCell);
